let instance = null

class Services {
  constructor() {
    if (instance)
      throw new Error('Only one instance of services must be running')

    this._registry = []
    this._debug = false
  }

  /**
   * Get instance
   */
  static getInstance() {
    if (!instance) {
      instance = new Services()
    }

    return instance
  }

  /**
   * Get registry instance
   */
  get registry() {
    return this._registry
  }

  /**
   * Get current debug mode
   */
  get debug() {
    return this._debug
  }

  /**
   * Set debug mode enabled or disabled
   */
  set debug(debug) {
    this._debug = debug
  }

  /**
   * Register new service
   * @param {String} name name
   * @param {Any} service service
   * @param {Boolean} overwrite overwrite already exist service
   */
  register(name, service, options = null, overwrite = false) {
    let foundIndex = this._registry.findIndex(s => s.name === name)

    if (!overwrite && foundIndex >= 0) {
      if (this._debug)
        console.log(
          '[Services]: Already exists, return old instance => ' + name
        )

      return this._registry[foundIndex]
    }

    let _newService = {
      name: name,
      service: service.init(options, this)
    }

    if (overwrite && foundIndex >= 0) {
      this._registry.splice(foundIndex, 1)

      if (this._debug) console.log('[Services]: Service overwrite => ' + name)
    } else if (this._debug) {
      console.log('[Services]: New service registered => ' + name)
    }

    this._registry.push(_newService)

    // Register service in instance
    this[name] = _newService.service

    return _newService
  }

  /**
   * Unregister service
   * @param {String} name service name
   * @returns {Boolean} success or fail
   */
  unregister(name) {
    const foundIndex = this._registry.findIndex(s => s.name === name)

    if (foundIndex >= 0) {
      this._registry.splice(foundIndex, 1)

      delete this[name]

      if (this._debug) console.log('[Services]: Unregister Service => ' + name)

      return true
    } else {
      if (this._debug) console.log("[Services]: Can't find Service => " + name)

      return false
    }
  }
}

export default Services.getInstance()
